<template>
  <div style="padding-bottom: 50px">
    <div class="dataAnalysisActionPlan">
        <div id="radarChartContainer" v-show="selectOptions.length>0">
          <div class="title" style="text-align: center">行动计划数据表</div>
          <div>
            <el-select v-model="selectValue1"  @change="selectChange" placeholder="请选择">
              <el-option
                  v-for="(item,key) in selectOptions"
                  :key="key"
                  :label="item.value"
                  :value="key">
              </el-option>
            </el-select>
            <div style="overflow: hidden;margin-top: 10px">
              <ul class="colorList">
                <li>
                  <span style="background:#52C0FF"></span>
                  任务完成得分
                </li>
                <li>
                  <span style="background:#2496D7"></span>
                  任务效果得分
                </li>
                <li>
                  <span style="background:#FFDF25"></span>
                  任务数量
                </li>
              </ul>
            </div>
            <div id="radarChartContainerChart1">
            </div>
          </div>
      </div>
      <div v-show="selectOptions.length==0" class="noContent">
        <NoContent></NoContent>
      </div>
    </div>
  </div>
</template>
<script>
import NoContent from '@/components/NoContent.vue'
export default {
  name: "grade",
  components:{NoContent},
  data(){
    return{
      data:[],
      options:{},
      selectOptions:[],
      data1:[],
      data2:[],
      data3:[],
      data4:[],
      data5:[],
      selectValue1:''
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_acapi + this.ports.parent.student.dataAnalysis.actionPlan, {
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.data=res.data.data;
          this.dataChange(res.data.data)
        } else {
        }
      })
    },
    dataChange(data){
      const {selectOptions} = this;
      let data1=[],data2=[],data3=[],data4=[],data5=[];
      data.forEach((item,key)=>{
        if(item.length!=0){
          let arr=[],arr2=[],arr3=[],arr4=[],arr5=[];
          if(key==0){
            selectOptions.push({
              value:'初一上学期'
            })
          }
          if(key==1){
            selectOptions.push({
              value:'初一下学期'
            })
          }
          if(key==2){
            selectOptions.push({
              value:'初二上学期'
            })
          }
          if(key==3){
            selectOptions.push({
              value:'初二下学期'
            })
          }
          if(key==4){
            selectOptions.push({
              value:'初三上学期'
            })
          }
          if(key==5){
            selectOptions.push({
              value:'初三下学期'
            })
          }
          if(key==6){
            selectOptions.push({
              value:'高一上学期'
            })
          }
          if(key==7){
            selectOptions.push({
              value:'高一下学期'
            })
          }
          if(key==8){
            selectOptions.push({
              value:'高二上学期'
            })
          }
          if(key==9){
            selectOptions.push({
              value:'高二下学期'
            })
          }
          if(key==10){
            selectOptions.push({
              value:'高三上学期'
            })
          }
          if(key==11){
            selectOptions.push({
              value:'高三下学期'
            })
          }
          if(item.month.length!=0){
            item.month.forEach((item2,key2)=>{
              if(item2.length!=0){
                let month='';
                if(key2==0){
                  month='第一次月考';
                }
                if(key2==1){
                  month='第二次月考';
                }
                if(key2==2){
                  month='第三次月考';
                }
                if(key2==3){
                  month='第四次月考';
                }
                item2.actionPlan&&item2.actionPlan.forEach((item3,key3)=>{
                  arr.push(item3.name+'行动计划')
                  // arr2.push('')
                  arr3.push(item3.taskComplete)
                  arr4.push(item3.completeEffect)
                  arr5.push(item3.taskNumber)
                })
                arr2.push(month)
                // let len=item2.actionPlan?item2.actionPlan.length:''
                // if(len==1){
                //     arr2[0]=month
                // }
                // if(len==2){
                //     arr2[1]=month
                // }
                // if(len==3){
                //     arr2[1]=month
                // }
                // if(len==4){
                //     arr2[2]=month
                // }
              }
            })
          }
          data1.push(arr)
          data2.push(arr2)
          data3.push(arr3)
          data4.push(arr4)
          data5.push(arr5)
        }
      })
      this.selectOptions=selectOptions
      this.data1=data1;
      this.data2=data2;
      this.data3=data3;
      this.data4=data4;
      this.data5=data5;
      if((data1.length==0)&&(data2.length==0)&&(data3.length==0)&&(data4.length==0)&&(data5.length==0)){
        return
      }
      this.selectValue1=selectOptions[0]?selectOptions[0].value:''
      this.$nextTick(()=>{
        this.draw(data1[0],data2[0],data3[0],data4[0],data5[0])
      })

    },
    draw(data1,data2,data3,data4,data5){
      let myChart = this.$echarts.init(document.getElementById('radarChartContainerChart1'));
      // 基于准备好的dom，初始化echarts实例

        let options = {
          grid: {
            y2: 140,
            left: '4%',
            right: '4%',
            top: '4%'
          },
          color: ['#52C0FF', '#2496D7', '#FFB200'],
          xAxis: [{
            type: 'category',
            data: data1,
            axisLabel: {
              interval: 0,
              rotate: 60,
              formatter: function (value) {
                let str = value.slice(0, 3)
                let str2 = value.slice(3)
                return str + '\n' + str2
              },
              fontSize: 12,
              align: 'center',
              padding: [30, 36, 0, 0],
              textStyle: {
                color: '#666666'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#cccccc'
              }
            },
          },
            {
              type: 'category',
              position: 'bottom',
              offset: 60,
              axisPointer: {
                type: 'none'
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                inside: false,
                textStyle: {
                  fontSize: 16,
                  padding: [5, 20, 3],
                  backgroundColor: '#F0F9FE',
                  color: 'rgba(0, 162, 255, 0.68)',
                  borderColor: '#52C0FF',
                  borderWidth: 1
                },
                interval: 0
              },
              data: data2
            },
          ],
          yAxis: [{
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#cccccc'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#666666'
              }
            },
            min: 0,
            splitNumber: 10,
            max: Math.ceil(Math.max(...data3) / 100) * 100,
          },
            {
              type: 'value',
              splitLine: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#cccccc'
                }
              },
              axisLabel: {
                textStyle: {
                  color: '#666666'
                },
              },
              min: 0,
              splitNumber: 10,
              max: Math.ceil(Math.max(...data5) / 100) * 100,
            },

          ],
          series: [
            {
              name: '任务完成得分',
              data: data3,
              type: 'bar',
              itemStyle: {
                normal: {
                  label: {
                    show: true,		//开启显示
                    position: 'top',	//在上方显示
                    textStyle: {	    //数值样式
                      color: '#333',
                      fontSize: 12
                    }
                  }
                }
              },
              barMaxWidth: 50,
              barMinWith: 20
            },
            {
              name: '任务效果得分',
              data: data4,
              type: 'bar',
              itemStyle: {
                normal: {
                  label: {
                    show: true,		//开启显示
                    position: 'top',	//在上方显示
                    textStyle: {	    //数值样式
                      color: '#333',
                      fontSize: 12
                    }
                  }
                }
              },
              barMaxWidth: 50,
              barMinWith: 20
            },
            {
              name: '排名',
              data: data5,
              type: 'line',
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  label: {
                    show: true,		//开启显示
                    position: 'top',	//在上方显示
                    textStyle: {	    //数值样式
                      color: '#666',
                      fontSize: 12
                    }
                  }
                }
              }
            }
          ],
          dataZoom: [
            {
              height: 14,
              type: "slider",
              show: true,
              xAxisIndex: [0, 1],
              bottom: 0,
              start: 0,
              end: 75,
              showDetail: false
            },
          ],
        }
        myChart.setOption(options);
    },
    selectChange(value){
      this.draw(this.data1[value],this.data2[value],this.data3[value],this.data4[value],this.data5[value])
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
.dataAnalysisActionPlan{
  background: #fff;
  padding: 0 20px 30px;
  .title{
    font-size: 18px;
    font-weight: 600;
    color: #5C5C5C;
    line-height: 40px;
    margin-bottom: 10px;
  }
  table, th, td {
    border: 1px solid #CDE9F8;
    color: #5C5C5C;
    font-size: 14px;
  }
  table {
    font-size: 16px;
    border-collapse: collapse;
    width: 100%;
    text-align: center;
  }
  td,th{
    line-height: 44px;
  }
  th {
    background: #F0F9FE;
    font-weight: bold;
  }
  .border0{
    padding: 0;
    //vertical-align:text-top;
  }
  .table{
    border-style:hidden;
    border-width:0;
  }
  .table2{
    td{
      line-height: 22px;
    }
  }
  #radarChartContainer{
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    position: relative;
    margin-bottom:80px;
  }
  .colorList{
    float: right;
    line-height: 30px;
    padding-right: 10px;
    li{
      float: left;
      span{
        display: inline-block;
        width: 15px;
        height: 8px;
        background: #52C0FF;
        margin-right: 5px;
        position: relative;
        top:-1px;
      }
      font-size:13px;
      color:#5C5C5C;
      margin-left:20px
    }
  }
  #radarChartContainerChart1,#radarChartContainerChart2{
    width: 100%;
    height: 520px;
  }
}
</style>
<style lang="less">
.dataAnalysisActionPlan{
  .el-input--suffix{
    border: 1px solid #DCDFE6;
    margin-right: 20px;
    width: 160px;
  }
  .el-input__inner{
    line-height: 32px !important;
    height: 32px !important;
  }
  .el-icon-arrow-up{
    line-height: 32px;
  }
  .el-radio{
    margin-right: 10px;
  }
  .el-checkbox-group{
    label{
      display: block;
      margin-top: 14px;
    }
  }
}
</style>